<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form role="form">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold row"><i class="fi fi-brands-whatsapp"
              style="color: #00AB4F; margin-right: 10px; margin-left: 10px;"></i> {{ type === 2 ? 'WhatsApp Validator' : 'Scan QR WhatsApp' }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fi fi-rr-cross-small"></i>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="type === 1" class="form-control bos-alert-primary lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px;">
            <div class="row">
              <div class="col-auto d-flex align-items-center">
                <i class="fi fi-rr-info d-flex align-items-center"></i>
              </div>
              <div class="col d-flex align-items-center">
                <div class="text-md">
                  Dengan menggunakan fitur scan WhatsApp, anda dapat mengirimkan pesan otomatis kepada penerima saat paket dijemput, sedang dikirim, atau jika mengalami kendala pengantaran.
                </div>
              </div>
            </div>
          </div>
          <div v-if="type === 2" class="form-control lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px; background-color: #FFF4DE; border-color: #FFA800;">
            <div class="row">
              <div class="col-auto d-flex align-items-start">
                <i class="fas fa-exclamation-triangle mt-1" style="color: #FFA800; font-size: 20px;"></i>
              </div>
              <div class="col d-flex align-items-center">
                <div>
                  <div class="font-weight-bold text-md" style="color: #D9822B;">Peringatan</div>
                  <div class="text-sm" style="color: #D9822B;">
                    <ul class="pl-3 mb-0">
                      <li>Nomor WhatsApp yang <b>disambungkan sebagai validator</b> tidak akan digunakan untuk <b>mengirim pesan notifikasi tracking</b> ke pelangganmu</li>
                      <li>Fitur dalam <b>tahap percobaan</b> dan berpotensi membuat <b>WhatsApp-mu terblokir</b>. Pastikan kamu <b>paham dengan resiko</b> tersebut</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group px-0 px-sm-3" style="display: flex; justify-content: center; align-items: center;">
            <div>
              <div class="row">
                <div class="col-8 d-flex flex-column">
                  <h6 class="mb-3">
                    <b class="text-sm">Untuk memulai mengirimkan notifikasi ke penerima secara otomatis,
                      kamu dapat scan QR dengan WhatsApp kamu.</b>
                  </h6>
                  <template v-if="type === 1">  
                    <div class="d-flex mb-2">
                      <div style="min-width: 25px;"><div class="text-md">1.</div></div>
                      <div><div class="text-md">Ini adalah layanan premium yang bisa didapatkan secara gratis dari bosCOD yang digunakan untuk notifikasi transaksi kamu</div></div>
                    </div>
                    
                    <div class="d-flex mb-2">
                      <div style="min-width: 25px;"><div class="text-md">2.</div></div>
                      <div><div class="text-md">Kamu setuju untuk tidak menggunakan layanan ini untuk spam dan mengirimkan pesan massal</div></div>
                    </div>

                    <div class="d-flex mb-2">
                      <div style="min-width: 25px;"><div class="text-md">3.</div></div>
                      <div><div class="text-md">Kami sarankan untuk tidak menggunakan nomor telepon baru (kurang dari 1 bulan) atau nomor telepon pribadi untuk meminimalisir resiko nomor terblokir oleh pihak WhatsApp</div></div>
                    </div>

                    <div class="d-flex mb-2">
                      <div style="min-width: 25px;"><div class="text-md">4.</div></div>
                      <div><div class="text-md">Fitur ini tidak ter-afiliasi langsung dengan sistem resmi dari WhatsApp, jadi mohon digunakan dengan bijak</div></div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="d-flex mb-2">
                      <div style="min-width: 25px;"><div class="text-md">1.</div></div>
                      <div><div class="text-md">Kamu setuju untuk tidak menggunakan layanan ini untuk spam</div></div>
                    </div>

                    <div class="d-flex mb-2">
                      <div style="min-width: 25px;"><div class="text-md">2.</div></div>
                      <div><div class="text-md">Kami sarankan untuk tidak menggunakan nomor telepon baru (kurang dari 1 bulan) atau nomor telepon pribadi untuk meminimalisir resiko nomor terblokir oleh pihak WhatsApp</div></div>
                    </div>

                    <div class="d-flex mb-2">
                      <div style="min-width: 25px;"><div class="text-md">3.</div></div>
                      <div><div class="text-md">Fitur ini tidak ter-afiliasi langsung dengan sistem resmi dari WhatsApp, jadi mohon digunakan dengan bijak</div></div>
                    </div>
                  </template>
                  
                  <div v-if="type === 1" class="form-control bos-alert-warning lh-1 d-flex align-items-center h-auto py-2 mt-auto" style="margin-bottom: 0;">
                    <div class="row">
                      <div class="col-auto d-flex align-items-center">
                        <i class="fas fa-lightbulb" style="color: #D9822B; font-size: 20px;"></i>
                      </div>
                      <div class="col d-flex align-items-center">
                        <div class="text-md">
                          Belum menemukan fitur scan WhatsApp? Yuk, langsung cek tutorial lengkapnya di sini! <a type="button"
                            style="color: #00AB4F; font-weight: bold;" @click="tutorial()">Tutorial Scan WhatsApp</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="type === 2" class="form-control bos-alert-primary lh-1 d-flex align-items-center h-auto py-2 mt-auto" style="margin-bottom: 0;">
                    <div class="row">
                      <div class="col-auto d-flex align-items-center">
                        <i class="fi fi-rr-info d-flex align-items-center"></i>
                      </div>
                      <div class="col d-flex align-items-center">
                        <div class="text-sm">
                          Gunakan nomor WhatsApp yang <b>tidak kamu pakai</b> atau <b>bukan nomor utama</b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4 d-flex flex-column">
                  <div id="qr_code" v-bind:class="{ 'skeleton-item': loading }" style="width: 200px; height: 200px; margin: 20px; background-color: white;">
                    <qr-code v-show="qr_code !== ''" :text="qr_code" :size="200" title="QR Code" error-level="L" style="pointer-events: none;"></qr-code>
                  </div>
                  <button type="button" class="btn btn-outline-info w-100 mt-auto" :disabled="loading || qr_code !== ''" @click="getQRCode(type)">
                    Minta Kode QR Baru
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueQRCodeComponent from 'vue-qrcode-component';
import Swal from 'sweetalert2';

Vue.component('qr-code', VueQRCodeComponent);

export default {
  name: "WhatsAppQRScan",
  emits: ['tutorialClicked', 'afterScan', 'rescan'],
  data() {
    return {
      type: 1, // 1: notification device, 2: validation device
      phone: null,
      qr_code: '',
      loading: false,
      controller: null,
    }
  },
  mounted() {
		this.customSwal = Swal.mixin({
			customClass: {
				title: 'h4 tex-dark',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary w-49 font-weight-bold py-3',
				denyButton: 'btn btn-outline-primary w-49 font-weight-bold py-3',
				cancelButton: 'btn btn-primary btn-block font-weight-bold py-3',
			},
			buttonsStyling: false
		});
	},
  methods: {
    getImage(file) {
			return require(`../assets/img/${file}.png`);
		},
    async getQRCode(type = 1) {
      this.type = type;

      if (this.controller) {
        this.controller.abort();
      }

      this.controller = new AbortController();
      
      if (this.loading && this.qr_code === '') {
        return;
      }

      try {
        const data_token = await JSON.parse(localStorage.getItem('APP_TOKEN'));
        let token = data_token.accessToken;

        this.qr_code = '';
        this.loading = true;

        if (data_token.exp < Date.now()) {
          if (!data_token.status) {
            localStorage['APP_TOKEN'] = '';
            location.href = '/login';
            return;
          }
          
          await fetch(window.$apiUrl + '/login/update_token', {
            method: 'POST',
            body: window.$crossDomain !== false ? data_token['refreshToken'] : ''
          })
          .then(r => {
            return r.json()
          })
          .then(json => {
            if (json.status) {
              localStorage['APP_TOKEN'] = JSON.stringify(json);
              token = json.accessToken;
            }
          });
        }

        const waUrl = process.env.VUE_APP_WA_SERVICE_URL;
        const url = new URL(`${waUrl}/api/whatsapp/qr-code`);
        url.searchwidth = '';

        if (this.phone) url.searchParams.append('phone', this.phone);

        url.searchParams.append('type', this.type);

        if (!this.controller) return;

        const response = await fetch(url.toString(), {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          signal: this.controller.signal
        });

        // Cek apakah response status adalah 200
        if (!response.ok || !response.body) {
          this.loading = false;
          this.qr_code = '';
          
          this.customSwal.fire({
            html: '<img src="' + this.getImage('error') + '" class="d-block w-75 m-auto" />Maaf, terjadi kesalahan saat menyambungkan.<br />Silahkan scan barcode WhatsApp lagi.',
            showConfirmButton: true,
            confirmButtonText: 'Scan Kembali',
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.loading = false;
              this.qr_code = '';
              this.$emit('rescan', this.type);
            }
          });
          
          return;
        }

        const reader = response.body.getReader();

        while (true) {
          const { done, value } = await reader.read()

          if (done) {
            break;
          }

          // Mengkonversi Uint8Array ke text
          const text = new TextDecoder().decode(value);

          if (text == 'auth_failure') {
            this.customSwal.fire({
              html: '<img src="' + this.getImage('error') + '" class="d-block w-75 m-auto" />Maaf, terjadi kesalahan saat menyambungkan.<br />Silahkan scan barcode WhatsApp lagi.',
              showConfirmButton: true,
              confirmButtonText: 'Scan Kembali',
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.loading = false;
                this.qr_code = '';
                this.$emit('rescan', this.type);
              }
            });
          } else if (text == 'connected' || text == 'authenticated' || text == 'already_used') {
            this.$emit('afterScan', text);
            this.loading = false;
            this.qr_code = '';
            this.phone = null;
          } else if (text == 'disconnected') {
            this.loading = false;
            this.qr_code = '';
          } else {
            this.qr_code = text;
            this.loading = false;
          }
        }
      } catch (error) {
        if (error.name === 'AbortError') return;

        console.error('Error:', error);
        this.loading = false;
        this.qr_code = '';
        this.phone = null;
        
        this.customSwal.fire({
          html: '<img src="' + this.getImage('error') + '" class="d-block w-75 m-auto" />Maaf, terjadi kesalahan saat menyambungkan.<br />Silahkan scan barcode WhatsApp lagi.',
          showConfirmButton: true,
          confirmButtonText: 'Scan Kembali',
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading = false;
            this.qr_code = '';
            this.$emit('rescan', this.type);
          }
        });
      }
    },
    closeConnection() {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      this.loading = false;
      this.qr_code = '';
    },
    tutorial() {
      this.$emit('tutorialClicked');
    }
  }
}
</script>
